<template>
  <div class="contact-info-container">

    <!-- 公司地址 -->
    <div class="contact-section mb-6">
      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <v-icon color="primary" size="20">mdi-office-building-marker</v-icon>
        </div>
        <div class="contact-content">
          <p class="contact-text">{{ safeT('brand.addressLabel', 'Address: ') }}{{ safeT('brand.address', 'Room 210, Building 1, Shahu Science and Technology Park, No.183, Tinglan Lane, Suzhou Industrial Park, P.R.China') }}</p>
        </div>
      </div>
    </div>

    <!-- 生产基地 -->
    <div class="contact-section mb-6">
      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <v-icon color="primary" size="20">mdi-factory</v-icon>
        </div>
        <div class="contact-content">
          <p class="contact-text">{{ safeT('brand.productionBaseLabel', 'Production Base: ') }}{{ safeT('brand.productionBase', 'Fangcheng Sub-district, Fangzi District, High-tech Zone, Weifang City, Shandong Province, P.R.China') }}</p>
        </div>
      </div>
    </div>

    <!-- 联系电话 -->
    <div class="contact-section mb-6">
      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <v-icon color="primary" size="20">mdi-phone</v-icon>
        </div>
        <div class="contact-content">
          <p class="contact-text">
            <a :href="'tel:' + safeT('brand.phone', '+86 15206211582')" class="contact-link">
              {{ safeT('brand.phone', '+86 15206211582') }}
            </a>
          </p>
        </div>
      </div>
    </div>

    <!-- 第二个电话 -->
    <div class="contact-section mb-6">
      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <v-icon color="primary" size="20">mdi-phone</v-icon>
        </div>
        <div class="contact-content">
          <p class="contact-text">
            <a href="tel:+8613563489528" class="contact-link">
              +86 13563489528
            </a>
          </p>
        </div>
      </div>
    </div>

    <!-- 电子邮箱 -->
    <div class="contact-section mb-6">
      <div class="contact-item">
        <div class="contact-icon-wrapper">
          <v-icon color="primary" size="20">mdi-email</v-icon>
        </div>
        <div class="contact-content">
          <p class="contact-text">
            <a :href="'mailto:' + getEmailAddress()" class="contact-link">
              {{ getEmailAddress() }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global'
})

// 安全的翻译获取函数，带fallback
const safeT = (key: string, fallback: string) => {
  try {
    const result = t(key)
    // 检查是否返回了翻译键本身（表示翻译失败）
    if (result && result !== key && !result.startsWith(key.split('.')[0] + '.')) {
      return result
    }
  } catch (error) {
    console.warn('Translation error for key:', key, error)
  }
  return fallback
}

// 获取邮箱地址的专门函数，避免i18n编译问题
const getEmailAddress = () => {
  try {
    const result = t('brand.email')
    if (result && result !== 'brand.email' && !result.startsWith('brand.')) {
      return result
    }
  } catch (error) {
    console.warn('Translation error for brand.email:', error)
  }
  // 使用安全的fallback方式
  return 'sarah' + String.fromCharCode(64) + 'davol.com'
}
</script>

<style scoped>
.contact-info-container {
  background: #F5F7FA;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  height: 100%;
}

.contact-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
}

.contact-section {
  margin-bottom: 2rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.contact-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(var(--v-theme-primary), 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-content {
  flex: 1;
}

.contact-label {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.contact-text {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 0.25rem;
}

.contact-link {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
  font-weight: 500;
}

.contact-link:hover {
  text-decoration: underline;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.download-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.download-btn {
  justify-content: flex-start;
  text-transform: none;
  font-weight: 500;
}

.social-links {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.social-btn {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

</style> 